// eslint-disable-next-line no-new-func
Object.assign(Function('return this')(), {
    build: deploy.build,
});
